// extracted by mini-css-extract-plugin
module.exports = {"SPDealDetail":"DealMainSpLinks_SPDealDetail__WC2p3","SPDealDetailLink":"DealMainSpLinks_SPDealDetailLink__KTQb4","UnreadCountBadge":"DealMainSpLinks_UnreadCountBadge__kVvev"};